import { useTranslation } from 'react-i18next';

import { CustomModal } from 'components/shared';
import { useErrorDescriptions } from 'constants/errorDescriptions';
import { useModal } from 'hooks/useModal';
import { OrderDetailsDTO } from 'interfaces';
import { HTTPService } from 'service';
import { logNetworkError } from 'utils/logNetworkError';

import styles from './CloseOrderModal.module.css';

type CloseOrderModalProps = {
   orderId: string;
   onSuccessCloseOrder: (updatedOrder: OrderDetailsDTO) => void;
   opened: boolean;
   onClose: () => void;
};

const CloseOrderModal = ({
   orderId,
   onSuccessCloseOrder,
   opened,
   onClose,
}: CloseOrderModalProps) => {
   const { t } = useTranslation();
   const { isLoading, errorInfo, setIsLoading, setErrorInfo, closeModalHandler } = useModal({
      onClose,
   });

   const { DEFAULT_ERROR_DESCRIPTIONS } = useErrorDescriptions();

   const sendOrderForSettlement = () => {
      setIsLoading(true);
      HTTPService.changeOrderStatus(orderId, 'ENDED')
         .then(response => {
            closeModalHandler();
            onSuccessCloseOrder(response.data);
         })
         .catch(err => {
            setErrorInfo(DEFAULT_ERROR_DESCRIPTIONS.UNKNOWN);
            logNetworkError(err);
         })
         .finally(() => setIsLoading(false));
   };

   return (
      <CustomModal
         opened={opened}
         onClose={closeModalHandler}
         title={t('order_details_page.close_order')}
         innerTitle={t('common.warning')}
         icon="ALERT_TRIANGLE"
         primaryButtonProps={{
            text: t('order_details_page.close_order'),
            variant: 'filled-primary',
            onClick: sendOrderForSettlement,
         }}
         secondaryButtonProps={{
            text: t('common.cancel'),
            variant: 'text',
            onClick: closeModalHandler,
         }}
         isLoading={isLoading}
         error={errorInfo}
         modalContentClassName={styles.modalContent}
         leftSideModalContent
      >
         <>
            <p>{t('close_order_modal.confirmation')}</p>
            <p>{t('cancel_pallet_report_modal.irreversible')}</p>
         </>
      </CustomModal>
   );
};

export default CloseOrderModal;
